import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-154">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={onClose} data-id="element-155">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="bg-[#FAF7F2] rounded-sm shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-156">
            <div className="flex items-center justify-between p-6 border-b border-stone-200" data-id="element-157">
              <h2 className="text-2xl font-serif text-[#2D2A26]" data-id="element-158">{title}</h2>
              <button onClick={onClose} className="p-2 text-stone-500 hover:text-[#C4A35A] transition-colors rounded-full hover:bg-stone-100" data-id="element-159">
                <X className="w-5 h-5" data-id="element-160" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] prose prose-stone prose-sm" data-id="element-161">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}